import logo from './assets/img/aegis_logo_small.png';
import './App.css';
import React, {Component} from 'react';
import { Outlet } from "react-router-dom";
import { GlobalSiteContext } from "./context/GlobalSiteContext"
import { GlobalSiteContextProvider } from "./context/GlobalSiteContext"

class App extends Component 
{
	static contextType = GlobalSiteContext
	
	constructor() {
		super();
		this.state = {members: null,showAdvancedStat: false};
		this.toogleShowAdvancedStat = this.toogleShowAdvancedStat.bind(this);		
	}

	toogleShowAdvancedStat(){
		this.setState(prevState => ({
			showAdvancedStat: !prevState.showAdvancedStat
		  }));
	}
	toogleDarkMode() {
		document.documentElement.classList.toggle('dark')
		//<button onClick={this.toogleDarkMode}>DARK</button>
	}
	render() {
		return ( 
			<GlobalSiteContextProvider>
			<div className="App">
				<header className="App-header" >
					<img src = {logo} className="App-logo" alt="logo" / >
					<p>AEGIS TRACKER</p> 
				</header>
				<Outlet />	
			</div>
			</GlobalSiteContextProvider>
		)
	};
}
export default App;